import AxiosClient from "./axios";
import CookieInstance from "./cookie";
import * as localStorage from "./localStorage";

const COOKIE_NAME = process.env.REACT_APP_COOKIE_NAME || "userToken";

const decodeTokenPayload = (token) => {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - (normalizedPayload.length % 4)) % 4);
    return JSON.parse(window.atob(`${normalizedPayload}${padding}`));
  } catch (error) {
    return null;
  }
};

// TODO: pin a single claim name (e.g. "sub") once the backend contract is
// confirmed. The multi-claim fallback below is acknowledged tech debt.
const getUserId = (payload) => {
  if (!payload) return null;

  const userId =
    payload.userId ||
    payload.user_id ||
    payload.accountId ||
    payload.account_id ||
    payload.id ||
    payload.sub ||
    payload.user?.id ||
    payload.profile?.id ||
    payload.data?.id;

  return userId === undefined || userId === null || userId === ""
    ? null
    : userId;
};

const getUsername = (payload) => {
  if (!payload) return null;

  const username =
    payload.username ||
    payload.user_name ||
    payload.userName ||
    payload.accountName ||
    payload.account_name ||
    payload.user?.username ||
    payload.profile?.username;

  return username === undefined || username === null || username === ""
    ? null
    : username;
};

// Tokens without an "exp" claim are considered valid client-side; the server
// remains the authority on signature and expiry enforcement.
const isTokenExpired = (payload) => {
  if (!payload || payload.exp === undefined) return false;
  return payload.exp <= Date.now() / 1000;
};

const clearAuthState = () => {
  CookieInstance.removeCookie(COOKIE_NAME);
  AxiosClient.setHeader();
  localStorage.removeItem("profile");
};

export const applyAuthToken = (token) => {
  // Validate the token BEFORE touching any state. A token link can arrive
  // in a browser holding a previous account's session; an invalid or
  // expired token must leave that session wiped instead of half-set.
  const payload = decodeTokenPayload(token);
  const userId = getUserId(payload);
  if (userId === null || isTokenExpired(payload)) {
    clearAuthState();
    return { ok: false, userId: null };
  }

  CookieInstance.setCookie(COOKIE_NAME, token);
  AxiosClient.setHeader(token);
  const username = getUsername(payload);
  localStorage.setItem("profile", {
    id: userId,
    ...(username ? { username } : {}),
  });
  return { ok: true, userId };
};
